import { ExpressionConfig } from '../../../dorian-shared/types/character/ExpressionConfig';
import { crossCommandKeysExpressionsForStep } from '../types/EpisodeTextImportCrossCommands';
import { TEpisodeTextImportCommands } from '../types/episodeTextImportCommandTypes';
import { EpisodeTextImportHelper } from '../models/EpisodeTextImportHelper';

/**
 * Resolve expression command from a step's commands Map to a numeric expression ID.
 *
 * Reused by:
 * - buildEditContextPayload (Selective Edit diff builder)
 * - useImportTextNodeManage (Text Import step creation)
 *
 * @returns expression id if a known expression command is found, undefined otherwise
 */
export function resolveExpressionId(
  commands: TEpisodeTextImportCommands,
  possibleExpressions: ExpressionConfig[],
): number | undefined {
  const record = EpisodeTextImportHelper.convertCommandsToRecordType(commands);
  const expression = crossCommandKeysExpressionsForStep.find((key) => record[key].size > 0);
  return expression ? possibleExpressions.find((el) => el.value === expression)?.id : undefined;
}
